<template>
  <draggable
    ref="drag"
    v-model="unallocated"
    v-bind="dragOptions"
    multi-drag
    selected-class="multi-drag"
    @update="onUpdate"
    @add="onAdd"
    @remove="onRemove"
    @start="onDragStart"
    @end="onDragEnd"
    style="min-height: 520px"
  >
    <delivery-card
      v-for="delivery in virtualNfesList"
      :key="delivery.id"
      :isCollapsed="isCollapsed"
      :unallocatedDelivery="delivery"
      :selected="selectedDeliveries[delivery.id]"
      :isDragable="true"
      @update:selected="$emit('update:selected', delivery.id)"
      :class="{ selected: selectedDeliveries[delivery.id] }"
    />
    <div v-if="unallocated.length" v-observe-visibility="handleDeliveriesScroll"></div>
    <div class="d-flex justify-center align-center py-3" v-if="unallocated.length == 0">Nenhuma entrega encontrada</div>
  </draggable>
</template>

<script>
import DeliveryCard from '@/components/ManualBoardingImport/Stepper/Step4/DeliveryCard.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
    DeliveryCard
  },
  props: {
    deliveries: {
      type: Array,
      default: () => []
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    selectedDeliveries: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dragOptions: {
        animation: 150,
        group: 'deliveryAllocation',
        ghostClass: 'ghost',
        disabled: false,
        handle: '.handle-drag'
      },
      isDragging: false,
      deliveriesToShow: 10
    };
  },
  computed: {
    unallocated: {
      get() {
        return this.deliveries;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    localSelectedNfe: {
      get() {
        return this.selectedDeliveries;
      },
      set(newVal) {
        this.$emit('update:selectedDeliveries', newVal);
      }
    },
    virtualNfesList() {
      return this.unallocated.slice(0, this.deliveriesToShow);
    }
  },
  methods: {
    onDragStart(e) {
      this.isDragging = true;
      e.item._selected_items = this.unallocated.filter((f) => this.localSelectedNfe[f.id]);
    },
    onDragEnd() {
      this.isDragging = false;
    },
    onUpdate(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
        unallocated.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocated = unallocated;
      }
    },
    onRemove(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        this.unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
      }
    },
    onAdd(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocated = this.unallocated.filter((f) => !ids.includes(f.id));
        unallocated.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocated = unallocated;
      }
    },
    handleDeliveriesScroll(isVisible) {
      if (!isVisible || this.deliveriesToShow >= this.unallocated.length) return;
      this.deliveriesToShow += 5;
    }
  }
};
</script>
<style scoped>
.ghost {
  display: none;
}
</style>
